export default __webpack_public_path__ + "static/media/Poppins-SemiBold.8a564c6b.eot";